/**
 * Number of companies to load per page/scroll
 * @constant {number}
 */
export const ITEMS_PER_PAGE = 50;

/**
 * Distance from bottom (in pixels) to trigger infinite scroll load
 * @constant {number}
 */
export const SCROLL_THRESHOLD_PIXELS = 300;

/**
 * Throttle delay for scroll events (in milliseconds)
 * @constant {number}
 */
export const SCROLL_THROTTLE_DELAY = 200;

/**
 * Debounce delay for search input (in milliseconds)
 * @constant {number}
 */
export const DEBOUNCE_DELAY = 500;

